<template>
  <b-container id="body-container" fluid>
    <b-row class="justify-content-center">
      <b-col cols="10">






        <!--
         <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="3">
            <span>
              <h4 class="text-blackish title-body">About Us</h4>
            </span>
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" class="header-text-container">

          <b-col md="2" sm="12" style="align-content:center">
            <img alt="gravity logo" src="../../assets/planet-bullet.svg" width="150"/>
          </b-col>

          <b-col md="8">
              <h4 class="text-blackish">Build a strong foundation of fresh lead data and tools to help B2B startups expand their reach.</h4>

              <h4 class="text-blackish">Consistently add new tools that experiment with new b2b marketing strategies and advance the cutting edge.</h4>

          </b-col>
        </b-row>

        <b-row align-h="start" class="header-text-container">

          <b-col md="3" sm="12" style="align-content:center">
            <img alt="gravity logo" src="../../assets/about-us-planet.svg" width="250"/>
          </b-col>
          <b-col md="8">
              <h4 class="text-blackish">Build a strong foundation of fresh lead data and tools to help B2B startups expand their reach.</h4>

              <h4 class="text-blackish">Consistently add new tools that experiment with new b2b marketing strategies and advance the cutting edge.</h4>

          </b-col>
        </b-row>
        -->





        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="4" md="4">
            <div class="color-design"></div>
          </b-col>
          <b-col cols="8" md="4">
            <span>
              <h4 class="text-blackish title-body" style="text-align:center">Who We Are</h4>
            </span>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container" style="text-align: center">
          <b-col cols="12" md="12">
            <span>
              <h4 class="text-blackish">We are a distributed team of 12 experienced and cheerful people from 5 countries around the world.</h4>
            </span>
          </b-col>
        </b-row>


        <div class="decorator2">
          <img alt="gravity logo" src="../../assets/decorator2.png" />
        </div>

        <b-row>
          <b-col
            v-for="guest of ourFleet"
            :key="guest.id"
            md="4"
            class="mt-md-4"
          >
            <ourTeam :guest="guest" />
          </b-col>
        </b-row>

        <b-row align-center justify-center id="job-offers">
          <b-col md="12" cols="12" >
            <a
              href="https://zoom.us/webinar/register/WN_amII22BgS2C0_NlExIbqFw"
              target="_blank"
            >
              <b-button  align-v="center" class="job-offers-button">View Current Openings</b-button>
            </a>
          </b-col>
        </b-row>

        <b-row id="header-section-two" class="justify-content-center" style="padding-top: 60px">
        <b-col
          cols="10"
          class="d-flex justify-content-center flex-column trusted-container"
        >
        <b-row class="justify-content-center">
          <b-col cols="12" class="d-flex justify-content-center">
            <p class="text-white trusted-by-title">
              Trusted by
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center trusted-brands-container">
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-1.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-2.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-3.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-4.png"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center trusted-brands-container">
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-5.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-6.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-7.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-8.png"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

        <div class="decorator1">
          <img alt="gravity logo" src="../../assets/decorator1.png" />
        </div>

        <!--
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="4" md="4">
            <div class="color-design"></div>
          </b-col>

          <b-col cols="8" md="4">
            <span>
              <h4 class="text-blackish title-body" style="text-align:center">Gravity Values</h4>
            </span>
          </b-col>
        </b-row>
        -->

      </b-col>
    </b-row>


    <b-row id="launch-today-container" class="justify-content-center">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h4 class="text-blackish title-body" style="text-align:center; color:white">Launch Today!</h4>
            </span>
            <h4 class="text-blackish" style="text-align:center; color:white">Sign Up For Free</h4>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col md="12" cols="12" >
            <a
              href="/#fleet"
            >
              <b-button  align-v="center" class="free-trial-button">Explore Gravity Products</b-button>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/screens/home/header.sass
</style>

<script>
// components
import ourTeam from '@/components/ourTeam'

// data
import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: 'Body',
  components: {
    ourTeam
  },
  data: function() {
    return {
      liveStream: {},
      featureSpeaker: [],
      pastSpeakers: [],
      futureSpeakers: [],
      guests,
      yourHosts,
      timeToShow: 10,
      timer: null,
      currentDate: null,
      dayOfWeek: null,
      month: 1,
      day: 1,
      year: 2020,
      speakerSelection: 1,
      liveRightNow: 0,

      ourFleet:  [{
          id: 1,
          name: 'Bryan Colligan',
          position: 'Washington D.C.',
          title: 'Co-Founder & CTO',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/bryancolligan/',
          photoFileName: 'bryan-purple.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:2,
          name: 'Ross Gates',
          position: 'Washington D.C.',
          title: 'Co-Founder & Product',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/rossegates/',
          photoFileName: 'ross.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:3,
          name: 'Michael B. ',
          position: 'Gomel, Belarus',
          title: 'Full Stack Developer',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/michael-borisov/',
          photoFileName: 'michael.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:4,
          name: 'Carlos L.',
          position: 'Harbin City, China',
          title: 'UX Design',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/carloslastres/',
          photoFileName: 'carlos.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        // {id:5,
        //   name: 'Roberto M.',
        //   position: 'Costa Rica',
        //   title: 'Web Development',
        //   subtitle: '',
        //   speakingDate: '',
        //   linkedinURL: 'https://www.linkedin.com/in/robmoya/',
        //   photoFileName: 'rob.jpeg',
        //   datePretty: '',
        //   daysLeft: 0,
        //   speakerStatus: 0,
        //   cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
        //   trimColor: ''
        // },
        {id:6,
          name: 'Caleb G.',
          position: 'Washington D.C.',
          title: 'Backend Development',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/calebgates/',
          photoFileName: 'caleb.jpg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:7,
          name: 'Oksana V.',
          position: 'San Francisco, CA',
          title: 'Marketing',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/oksana-vlasenko-71366b162/',
          photoFileName: 'oksana.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:8,
          name: 'Alesia S.',
          position: 'San Francisco, CA',
          title: 'Marketing',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/alesia-samuilova-2b65a3ba/',
          photoFileName: 'Alesia.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:9,
          name: 'Vlad K.',
          position: 'Minsk, Belarus',
          title: 'Backend Development',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/vladyslav-kompaniiets-21819014b/',
          photoFileName: 'vlad.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:11,
          name: 'Jake G.',
          position: 'San Francisco, CA',
          title: 'Marketing & Growth',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/jake-greenwell-43608b117/',
          photoFileName: 'jake.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        {id:12,
          name: 'Jody K.',
          position: 'New York, NY',
          title: 'Marketing ',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/jodykung/',
          photoFileName: 'jody.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },

        { id:13,
          name: 'Drake D.',
          position: 'Dallas, TX',
          title: 'Sales Manager',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/drakedukes/',
          photoFileName: 'drake.jpg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },

        { id:14,
          name: 'Alex B.',
          position: 'Washington D.C.',
          title: 'Signal Consultant',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/alex-boronin-a208291ab/',
          photoFileName: 'alex-b.jpeg',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },
        //-------------- Past Eployees
        /* {id:10,
          name: 'Andres A.',
          position: 'Costa Rica',
          title: 'Web Development',
          subtitle: '',
          speakingDate: '',
          linkedinURL: 'https://www.linkedin.com/in/artaviandres/',
          photoFileName: 'andres.png',
          datePretty: '',
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
          trimColor: ''
        },*/
    ]

    }
  },
  computed: {
    timeLeft() {
      return `${this.minutes} m ${this.seconds} seconds`
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, '0')
    },
    seconds() {
      return String(this.time % 60).padStart(2, '0')
    },
  },
  created() {
    this.orderSpeakers()
    this.setSpeakerRoles()
    //this.timeToShow = this.getTimeToShow(),
    //this.timer = setInterval(this.decrement, 1000)
  },
  methods: {
    orderSpeakers() {
      var currentDate = new Date()

      this.guests.forEach((guestItem, index) => {
        var speakingDate = guestItem.speakingDate
        var year = parseInt(speakingDate.substr(0, 4))
        var month = parseInt(speakingDate.substr(5, 6)) - 1
        var day = parseInt(speakingDate.substr(8, 9))
        var speakerDate = new Date(year, month, day, 0, 0, 0)
        var timeLeft = (speakerDate - currentDate) / 86400000
        var daysLeft = Math.ceil(timeLeft)

        // Store the dates back into the array
        guestItem.daysLeft = timeLeft
        var datePretty = speakerDate.toString().substr(0, 10)
        var ending = [
          '',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ]
        if (ending[day] !== undefined) {
          datePretty += ending[day]
        } else {
          datePretty += 'th'
        }
        guestItem.datePretty = datePretty
        if (timeLeft < 1 && timeLeft > -0.082) {
          //this.featuredSpeaker = index
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < 3 && datePretty.substr(0, 3) === 'Mon') {
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < -0.041) {
          guestItem.speakerStatus = 0 // past
        } else {
          guestItem.speakerStatus = 2 // future
        }

        if (timeLeft < -0.041 && timeLeft > -0.082) {
          this.liveRightNow = 1
        }

        console.log(timeLeft)
        console.log(datePretty)
        console.log(daysLeft)
        console.log(index)
      })
    },
    setSpeakerSelection(page) {
      this.speakerSelection = page
    },
    setSpeakerRoles() {
      for (var i = 0; i < this.guests.length; i++) {
        if (this.guests[i].speakerStatus === 1) {
          console.log('Speaker Status')
          console.log(this.guests[i].speakerStatus)
          this.featureSpeaker.push(this.guests[i])
        } else if (this.guests[i].speakerStatus === 2) {
          this.futureSpeakers.push(this.guests[i])
        } else {
          this.pastSpeakers.push(this.guests[i])
        }
        this.liveStream = this.featureSpeaker[0]
      }
    },

    getTimeToShow() {
      // Get the day of the week = 2
      this.dayOfWeek
      // Get the current time = in date object
      this.currentDate
      // Make sure the timezone is correct

      // Timezone varies depending on Daylight Savings

      // Compare with current time in timezone SF
      // var pacificTime = new Date("2020-04-13T00:00:00.000+08:00")

      // Get Time Until 10:30 AM PST
      // If time before 10:30am PST
      // If time 10:30 - 11           M-F (Skip) Show LIVE NOW
      // If time after 11 am PST      Subtract Hours from 24

      // If Monday,Tuesday,Wed,Thurs

      // If Friday Afternoon

      // If Saturday    Add + 2 days

      // If Sunday morning      Add + 1 day (Afternoon subtract from 24)

      // If
      // If between 10:30 - 11:00 Monday - Friday (Skip) Show LIVE NOW
      //
    },
    decrement() {
      this.time = this.time - 1
    },
  },
}
</script>
